import { Dialog, DialogTitle, Divider } from "@material-ui/core";
import { MarkFmcsaInspectionUnofficialForm } from "./MarkFmcsaInspectionUnofficialForm";
import {
  FmcsaInspectionDto,
  FmcsaInspectionListDto,
} from "../../../common/data/service-proxies";

interface Props {
  record?: FmcsaInspectionDto | FmcsaInspectionListDto;
  isOpen: boolean;
  onClose: () => void;
  onSuccess?: () => void;
}

export const MarkFmcsaInspectionUnofficialDialog = ({
  record,
  isOpen,
  onSuccess,
  onClose,
}: Props) => {
  if (!record?.id) {
    return null;
  }

  return (
    <Dialog open={isOpen} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Confirm marking this inspection as unofficial</DialogTitle>
      <Divider />
      <MarkFmcsaInspectionUnofficialForm
        id={record.id}
        onSuccess={() => {
          if (onSuccess) {
            onSuccess();
          }
        }}
        onFailed={onClose}
      />
    </Dialog>
  );
};
